import React from 'react'
// import Sidebar from '../Components/Sidebar'
import RequestR from '../Components/RequestR'
import HeaderTwo from './HeaderTwo'
import SidebarLayout from '../Components/sidebar/SidebarLayout'


const Request = () => {
  return (
    <>
    <SidebarLayout>
      <HeaderTwo />
      <div id="wrapper" className="col-md-12">
        <div style={{ position: "relative" }}>
          {/* <Sidebar /> */}
          <RequestR/>
        </div>
      </div>
    </SidebarLayout>
    </>
  
  )
}

export default Request